import { faShoppingCart } from '@fortawesome/pro-regular-svg-icons';
import {
    faArrowLeft,
    faChevronDown,
    faComments,
    faCommentSmile,
    faSearch,
    faSoup,
    faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash-es/debounce';
import {
    counter_GROUP_MEMBERS,
    counter_GROUP_POSTS,
    ABOUT_SAME_DATE_GROUP,
    ADD_RECIPE,
    BACK_TO_LIST_OF_GROUPS,
    EXPLORE_NEIGHBOUR_DATE_GROUPS,
    GROUP_DESCRIPTION_AND_RULES,
    GROUP_FEED_counter_PRODUCTS_IN_location,
    GROUP_FEED_SEARCH_RESULT_query_count,
    GROUP_INFO_SHOW_WHOLE_DESCRIPTION,
    GROUP_MODERATORS_SHORT,
    GROUPS_SEARCH_PLACEHOLDER,
    HOMEPAGE_POST_TYPE_SHORT_MESSAGE,
    ORDER_BY,
    RECENT_COMMENTS,
    RECENT_POSTS, TERM_GROUP_GUIDE_WRITE_FIRST,
    WIKI_REVIEWS,
} from 'mk/autogenerated/translations/GroupFeed.303c6718b1d92e16a344de7333357be7'
import { urlize } from 'mk/bazaar/common/filters';
import { formatThousands } from 'mk/bazaar/common/formatters';
import assetUrl from 'mk/common/assetUrl';
import { getCountyName } from 'mk/geo';
import { photoUrl } from 'mk/photo/photoUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { bazaarUrl } from 'mk2/apps/bazaar/urls';
import {
    groupPostCreateFormName,
    BlogPostCreateFormFactory,
    BlogPostFormData,
} from 'mk2/apps/blogs/components/BlogPostCreateForm';
import SearchResults from 'mk2/apps/blogs/components/SearchResults';
import { GROUP_FEED_READ_TIMEOUT } from 'mk2/apps/blogs/constants';
import { blogsRecipeArticleCreateUrl } from 'mk2/apps/blogs/urls';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import GroupFeedPosts from 'mk2/apps/groups/components/GroupFeedPosts';
import GroupHeader, { GroupHeaderPlaceholder } from 'mk2/apps/groups/components/GroupHeader';
import { ConnectToGroup } from 'mk2/apps/groups/containers/GroupFeed/ConnectToGroup';
import { groupsGroupUrl, groupsListUrl } from 'mk2/apps/groups/urls';
import ReviewArticles, { LayoutType } from 'mk2/apps/wiki/components/ReviewArticles';
import { WIKI_REVIEWS_ARTICLE_SLUG } from 'mk2/apps/wiki/helpers';
import { Failure } from 'mk2/components/errors/Failure';
import { MenuItem } from 'mk2/components/menu/MenuItem';
import { Btn,  BtnLayout, BtnType } from 'mk2/components/Btn';
import { ClearableInput } from 'mk2/components/ClearableInput';
import { Dot } from 'mk2/components/Dot';
import { ExpandableClamp } from 'mk2/components/ExpandableClamp';
import { Img } from 'mk2/components/Img';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { Menu } from 'mk2/containers/Menu/Menu';
import { convertPhotoEntityToUploadedPhoto } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { getAllPlaintext } from 'mk2/helpers/article_ast/utils';
import { url } from 'mk2/helpers/urls';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { parse, stringify } from 'query-string';
import React from 'react';
import { GROUP_FEED_MENU_ORDERBY } from './GroupFeed.constants';
import styles from './GroupFeed.mscss';
import { OrderBy, Props, ScrollToPosition } from './GroupFeedPage';

const RECIPE_GROUPS = {
    201: [2000],
    202: [],
}[ACTIVE_SERVER_ID] || [];

interface State {
    query: string;
}

export const SAME_DATE_GROUP_CATEGORY_ID = 34;

class GroupFeed extends React.Component<Props, State> {

    private readTimer: number;
    private searchRedirectDebounced: () => void;
    private textArea: HTMLTextAreaElement;
    private BlogPostCreateForm = BlogPostCreateFormFactory(groupPostCreateFormName(
        this.props.groupId, this.props.pageRef,
    ));

    constructor(props: Props) {
        super(props);

        this.state = {
            query: props.query,
        };

        this.searchRedirectDebounced = debounce(this.searchRedirect, 500);
    }

    public componentDidMount() {
        const { lastVisitedCount, loadingState, onScrollTo } = this.props;

        if (lastVisitedCount) {
            this.readTimer = window.setTimeout(this.handleFeedRead, GROUP_FEED_READ_TIMEOUT);
        }

        if (loadingState === LoadingState.SUCCESS_ON_SERVER) {
            const qs = parse(this.props.location.search);
            if (qs.scrollto) {
                onScrollTo(qs.scrollto as ScrollToPosition);
            }
        }
    }

    public shouldComponentUpdate(n: Props, nextState: State) {
        const p = this.props;

        return p.group !== n.group
            || p.posts !== n.posts
            || p.askedForMembership !== n.askedForMembership
            || p.complaintsOpened !== n.complaintsOpened
            || p.isBlocked !== n.isBlocked
            || p.isMember !== n.isMember
            || p.isSubscribed !== n.isSubscribed
            || p.isSubscribing !== n.isSubscribing
            || p.isFavorite !== n.isFavorite
            || p.joining !== n.joining
            || p.orderBy !== n.orderBy
            || p.pageRef !== n.pageRef
            || p.query !== n.query
            || this.state.query !== nextState.query;
    }

    public UNSAFE_componentWillUpdate(nextProps: Props) {
        if (nextProps.pageRef !== this.props.pageRef) {
            this.BlogPostCreateForm = BlogPostCreateFormFactory(groupPostCreateFormName(
                nextProps.groupId, nextProps.pageRef,
            ));
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const p = this.props;

        if (p.lastVisitedCount) {
            window.clearTimeout(this.readTimer);
            this.readTimer = window.setTimeout(this.handleFeedRead, GROUP_FEED_READ_TIMEOUT);
        }

        // if becoming a member, load posts (a change from frontpage to posts feed)
        if (
            p.group && prevProps.group
            && (p.group.id === prevProps.group.id)
            && p.isMember !== prevProps.isMember
            && p.isMember) {
            this.load();
        }

        // close search input (if open) when switching to a different group
        if (p.groupId !== prevProps.groupId && this.state.query !== null) {
            this.setState({ query: null });
        }

        if (// zmenil sa feed (url) alebo page z feedu
            (p.location.pathname !== prevProps.location.pathname || p.pageRef !== prevProps.pageRef) &&
            // nevraciame sa cez 'Back'
            p.history.action !== 'POP' &&
            // a nacitali sme z cache (LoadingSwitch nespustil groupFeedFetchTrigger)
            isSuccess(p.loadingState)
        ) {
            // defaultne sa scrollne na konci fetchGroupFeed sagy, ale ta sa nespusti
            // tak vykonaj scroll side-effect
            const qs = parse(p.location.search);
            if (qs.scrollto) {
                p.onScrollTo(qs.scrollto as ScrollToPosition);
            }
        }
    }

    public componentWillUnmount() {
        window.clearTimeout(this.readTimer);
    }

    public render() {
        const {
            askedForMembership, group, isBlocked, isFavorite, isMember, isModerator, isSubscribed, isSubscribing,
            joining, loadingState, location, moderators, permissions, requestUser, staticContext, feedLoaded,
            onGroupAddToFavorites, onGroupSubscribe, onGroupRemoveFromFavorites, onGroupUnsubscribe, onInviteUser,
        } = this.props;

        const isDeleted = group && !!group.deletedAt;

        if (isDeleted && staticContext) {
            staticContext.statusCode = 410;
        }

        return (
            <div className={styles.GroupFeed}>
                {!group && ((loadingState === null || loadingState === LoadingState.INIT || loadingState === LoadingState.LOADING)) && (
                    <GroupHeaderPlaceholder />
                )}
                {(isSuccess(loadingState) || group) && (
                    <div>
                        <GroupHeader
                            group={group}
                            groupLoadingState={loadingState}
                            hasAskedForMembership={askedForMembership.includes(group.id)}
                            isBlocked={isBlocked}
                            isJoining={joining.includes(group.id)}
                            isMember={isMember}
                            isModerator={isModerator}
                            isSearchOpen={this.isShowingSearch()}
                            isSubscribed={isSubscribed}
                            isFavorite={isFavorite}
                            isSubscribing={isSubscribing}
                            location={location}
                            moderators={moderators}
                            recentContributors={group.activeMembersCount}
                            onInviteUser={onInviteUser}
                            onJoin={this.handleGroupJoin}
                            onLeave={this.handleGroupLeave}
                            onSearchClick={this.handleSearchClick}
                            onSubscribe={onGroupSubscribe}
                            onUnsubscribe={onGroupUnsubscribe}
                            onAddToFavorites={onGroupAddToFavorites}
                            onRemoveFromFavorites={onGroupRemoveFromFavorites}
                            permissions={permissions}
                            posts={this.props.posts}
                            requestUser={requestUser}
                        />
                    </div>
                )}
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInitAndSuccess}
                    onRenderSuccess={this.renderInitAndSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={feedLoaded}
                />
            </div>
        );
    }

    private renderInitAndSuccess = () => {
        const { group, isMember, permissions } = this.props;

        if (!group) {
            return this.renderInit();
        }

        const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;

        return (isMember || isAdmin)
            ? this.renderPosts()
            : this.renderFrontpage();
    };

    private renderPosts = () => {
        const {
            commentsCounts,
            complaintsCounts,
            complaintsOpened,
            count,
            errorMessage,
            group,
            hashtags,
            initialValues,
            isIOS,
            loadingState,
            location,
            isMobile,
            moderatorUsersByGroupId,
            numberOfPages,
            onChangeSticky,
            onDelete,
            onGroupFeedMenuOrderBy,
            onPostToggleMenuMore,
            onReport,
            onSetPrefillData,
            orderBy,
            pageRef,
            permissions,
            posts,
            feedLoaded,
            query,
            requestUser,
            staticContext,
            userAgent,
            countyId,
            productsCount,
            isCommented,
            isPosted,
            onGuideComplete,
            isClosed,
            isAdmin,
            promoReviewArticlesHeader,
            promoReviewArticlesMiddle,
            promoReviewArticlesFooter,
            hasRecipesAccess,
        }: Props = this.props;

        const BlogPostCreateForm = this.BlogPostCreateForm;
        let date = null;
        if (group.domainMonth !== null) {
            date = group.domainMonth.split('-').map((item) => {
                return parseInt(item, 10);
            });
        }
        const isGroupWithRecipes = (
            hasRecipesAccess &&
            RECIPE_GROUPS.includes(group.id)
        );

        const handleCreateRecipeFromPost = (postId: number) => {
            const post = posts.find(p => p.id === postId);
            if (post) {
                const photos = post.images?.length
                    ? post.images.map(image => convertPhotoEntityToUploadedPhoto(image.photo))
                    : undefined;
                const oneliner = post.perexAST ? getAllPlaintext(post.perexAST) : undefined;
                onSetPrefillData({ photos, oneliner, sourcePostId: post.id });
            }
            this.props.onStoreEvent('recipes_create_from_group_post_click', {
                post_id: postId,
                group_id: group.id,
            });
            this.props.history.push(url(blogsRecipeArticleCreateUrl, { username: requestUser.username }));
        };

        function isConnected () {
            // od 11/23
            if (date[0] > 2022 && date[1] > 10 || date[0] > 2023) {
                return (
                    <ConnectToGroup
                        isComment={isCommented}
                        isPost={isPosted}
                        group={group}
                        isClosed={isClosed}
                        onGuideComplete={onGuideComplete}
                    />
                    );
                }
        }

        return (
            <React.Fragment>
                {(this.isShowingSearch() && (
                    <div className={styles.GroupFeed__search__container}>
                        <ClearableInput
                            className={styles.GroupFeed__search__container__clearableInput}
                            icon={<label htmlFor="search"><FontAwesomeIcon icon={faSearch} /></label>}
                            hasValue={Boolean(this.state.query)}
                            onClear={this.onCancelFilters}
                        >
                            <input
                                id="search"
                                type="text"
                                value={this.state.query}
                                onChange={this.onSearchChange}
                                placeholder={GROUPS_SEARCH_PLACEHOLDER}
                                autoFocus
                            />
                        </ClearableInput>
                    </div>
                ))}

                {query && (
                    <SearchResults
                        loadingState={loadingState}
                        hasData={Boolean(posts && posts.length > 0)}
                        onCancelFilters={this.onCancelFilters}
                    >
                        <Interpolate
                            i18nKey={GROUP_FEED_SEARCH_RESULT_query_count}
                            query={<strong>{query}</strong>}
                            count={count}
                        />
                    </SearchResults>
                )}

                {!this.isShowingSearch() && (
                    <>
                        <BlogPostCreateForm
                            initialValues={initialValues}
                            isInGroups
                            isIOS={isIOS}
                            isMobile={isMobile}
                            linkTabs={isGroupWithRecipes ? [
                                {
                                    icon: faCommentSmile,
                                    label: HOMEPAGE_POST_TYPE_SHORT_MESSAGE,
                                },
                                {
                                    icon: faSoup,
                                    label: ADD_RECIPE,
                                    link: url(blogsRecipeArticleCreateUrl, { username: requestUser.username }),
                                },
                            ] : undefined}
                            onSave={this.handleOnSavePost}
                            requestUser={requestUser}
                            requestUserPermissions={permissions}
                            textareaRef={this.handleTextareaRef}
                        />

                        {!!productsCount && !!countyId && (
                            <div className={styles.GroupFeed__productsCount}>
                                <Btn
                                    type={BtnType.BlueOutline}
                                    link={url(bazaarUrl, {}, {locations: getCountyName(countyId)})}
                                    label={
                                        <>
                                            <FontAwesomeIcon icon={faShoppingCart} />&nbsp;
                                            <Interpolate
                                                i18nKey={GROUP_FEED_counter_PRODUCTS_IN_location}
                                                count={productsCount}
                                                counter={formatThousands(productsCount)}
                                                location={getCountyName(countyId)}
                                            />
                                        </>
                                    }
                                />
                            </div>
                        )}
                    </>
                )}
                {(Boolean(posts && posts.length > 0))  && (date !== null) && (
                    isConnected()
                )}
                {(promoReviewArticlesHeader.length > 0) &&
                    <ReviewArticles
                        articles={promoReviewArticlesHeader}
                        layout={LayoutType.COMPACT}
                        utmParams={{
                            utm_medium: 'widget',
                        }}
                    />
                }
                {(Boolean(posts && posts.length === 0)) && (date !== null) && (
                    <div className={styles.GroupFeed__writeFirst}>
                        <Img className={styles.GroupFeed__writeFirst__img} height={121} width={108} src={assetUrl + 'img/stickers/202/42.png'}/>
                        <div className={styles.GroupFeed__writeFirst__text}>
                            {TERM_GROUP_GUIDE_WRITE_FIRST}
                        </div>
                    </div>
                )}
                {(count > 0) && (
                    <div className={styles.GroupFeed__orderBy}>
                        <span className={styles.GroupFeed__orderBy__label}>{ORDER_BY}:</span>
                        <Menu
                            menuId={GROUP_FEED_MENU_ORDERBY}
                            trigger={(
                                <Btn
                                    type={BtnType.GreyText}
                                    icon={faChevronDown}
                                    label={orderBy === 'posts' ? RECENT_POSTS : RECENT_COMMENTS}
                                    layout={BtnLayout.LabelIcon}
                                    onClick={onGroupFeedMenuOrderBy}
                                />
                            )}
                            triggerShadow={false}
                        >
                            <MenuItem
                                label={RECENT_POSTS}
                                onClick={this.handleOrderByPosts}
                            />
                            <MenuItem
                                label={RECENT_COMMENTS}
                                onClick={this.handleOrderByComments}
                            />
                        </Menu>
                    </div>
                )}

                <div id="scrolltoFirstHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}

                <GroupFeedPosts
                    commentsCounts={commentsCounts}
                    complaintsCounts={complaintsCounts}
                    complaintsOpened={complaintsOpened}
                    errorMessage={errorMessage}
                    group={group}
                    hashtags={hashtags}
                    history={this.props.history}
                    location={location}
                    loadingState={loadingState}
                    isMobile={isMobile}
                    moderatorUsersByGroupId={moderatorUsersByGroupId}
                    numberOfPages={numberOfPages}
                    onChangeSticky={onChangeSticky}
                    onCreateRecipeFromPost={isGroupWithRecipes ? handleCreateRecipeFromPost : undefined}
                    onDelete={onDelete}
                    onPostToggleMenuMore={onPostToggleMenuMore}
                    onReport={onReport}
                    pageRef={pageRef}
                    permissions={permissions}
                    posts={posts}
                    feedLoaded={feedLoaded}
                    requestUser={requestUser}
                    showHashtagsBox
                    isGroupWithRecipes={isGroupWithRecipes}
                    showStrips
                    staticContext={staticContext}
                    userAgent={userAgent}
                    promoReviewArticlesMiddle={promoReviewArticlesMiddle}
                    isAdmin={isAdmin}
                />

                <div id="scrolltoLastHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
                {(promoReviewArticlesFooter.length > 0) &&
                    <div className={styles.GroupFeed__bottomWidget}>
                        <ReviewArticles
                            headerLogo
                            header={WIKI_REVIEWS}
                            headerLinkTo={`/${WIKI_REVIEWS_ARTICLE_SLUG}/?utm_medium=widget`}
                            articles={promoReviewArticlesFooter}
                            layout={LayoutType.HORIZONTAL}
                            utmParams={{
                                utm_medium: 'widget',
                            }}
                        />
                    </div>
                }
            </React.Fragment>
        );
    };

    private renderFrontpage = () => {
        const { group, moderators, neighbourGroups } = this.props;
        return (
            <div className={styles.GroupFeed__frontpage}>
                <div id="scrolltoFirstHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}

                {group.categoryId === SAME_DATE_GROUP_CATEGORY_ID && group.isDomainGroup ?
                    <div>
                        <div className={styles.GroupFeed__frontpage__aboutSameDateGroup}>
                            <Interpolate i18nKey={ABOUT_SAME_DATE_GROUP} parent="h4" className={styles.GroupFeed__frontpage__aboutSameDateGroup__text} />

                            <div className={styles.GroupFeed__frontpage__aboutSameDateGroup__stats}>
                                <FontAwesomeIcon icon={faUsers} className={styles.GroupFeed__frontpage__aboutSameDateGroup__stats__icon} />
                                <Interpolate i18nKey={counter_GROUP_MEMBERS} counter={group.membersCount} count={group.membersCount} parent="span" />
                                <Dot spaces={2} className={styles.GroupFeed__frontpage__aboutSameDateGroup__stats__dot} />
                                <FontAwesomeIcon icon={faComments} className={styles.GroupFeed__frontpage__aboutSameDateGroup__stats__icon} />
                                <Interpolate i18nKey={counter_GROUP_POSTS} counter={group.postsCount} count={group.postsCount} parent="span" />
                            </div>
                        </div>

                        {!!neighbourGroups?.length && (
                            <div className={styles.GroupFeed__frontpage__neighbourGroups}>
                                <div className={styles.GroupFeed__frontpage__neighbourGroups__header}>
                                    <h4 className={styles.GroupFeed__frontpage__neighbourGroups__heading}>
                                        {EXPLORE_NEIGHBOUR_DATE_GROUPS}
                                    </h4>
                                </div>
                                {neighbourGroups.map((neighbourGroup) => (
                                    <div key={neighbourGroup.id} className={styles.GroupFeed__frontpage__neighbourGroups__item}>
                                        <Img src={photoUrl(neighbourGroup.coverPhoto, 'c50x50')} width={40} height={40} className={styles.GroupFeed__frontpage__neighbourGroups__item__photo} />
                                        <div>
                                            <Link to={url(groupsGroupUrl, { groupId: neighbourGroup.id })} className={styles.GroupFeed__frontpage__neighbourGroups__item__name}>{neighbourGroup.name}</Link>
                                            <Interpolate i18nKey={counter_GROUP_POSTS} counter={neighbourGroup.postsCount} count={neighbourGroup.postsCount} className={styles.GroupFeed__frontpage__neighbourGroups__item__postsCount} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    : <>
                        <h4 className={styles.GroupFeed__frontpage__rules__heading}>
                            {GROUP_DESCRIPTION_AND_RULES}
                        </h4>
                        <ExpandableClamp expandLabel={GROUP_INFO_SHOW_WHOLE_DESCRIPTION} clamp={9}>
                            <div className={styles.GroupFeed__frontpage__rules__description}>
                                {urlize(group.description, 50)}
                            </div>
                        </ExpandableClamp>
                        <h4 className={styles.GroupFeed__frontpage__moderators__heading}>
                            {GROUP_MODERATORS_SHORT}
                        </h4>
                        <div>
                            {moderators.map((moderator) => (
                                <UserChip
                                    className={styles.GroupFeed__frontpage__moderators__moderator}
                                    key={moderator.user.username}
                                    size={36}
                                    user={moderator.user}
                                    vertical
                                />
                            ))}
                        </div>
                    </>}

                <div id="scrolltoLastHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
            </div>
        );
    };

    private renderInit = () => {
        return null;
    };

    private renderFailure = () => {
        const { errorMessage, staticContext } = this.props;

        return (
            <Failure
                staticContext={staticContext}
                errorMessage={errorMessage}
                onRetry={this.load}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_LIST_OF_GROUPS}
                        icon={faArrowLeft}
                        link={groupsListUrl}
                    />
                }
            />
        );
    };

    private isShowingSearch = () => this.state.query !== null;

    private load = () => {
        const { groupId, location, onLoad, orderBy, pageRef, posts, query } = this.props;
        const numPostsBeforeLoad = posts.length;
        onLoad(groupId, pageRef, orderBy, query, location, numPostsBeforeLoad);
    };

    private handleFeedRead = () => {
        const { group } = this.props;
        if (group) {
            this.props.onFeedRead(group.id);
        }
    };

    private handleGroupJoin = (groupId, username) => {
        this.props.onGroupJoin(groupId, 'feed');
    };

    private handleGroupLeave = (groupId, username) => {
        this.props.onGroupLeave(groupId);
    };

    private handleOrderByPosts = () => {
        this.handleOrderBy('posts');
    };

    private handleOrderByComments = () => {
        this.handleOrderBy('comments');
    };

    private handleOrderBy = (orderBy: OrderBy) => {
        if (this.props.orderBy !== orderBy) {
            this.commonRedirect(orderBy, this.state.query);
        }
    };

    private commonRedirect = (orderBy, query) => {
        const { match: { params } } = this.props;

        const search = {
            ...((query !== null) ? { query } : {}),
            ...((orderBy !== 'posts') ? { orderby: orderBy } : {}),
        };

        this.props.history.replace({
            pathname: url(groupsGroupUrl, params),
            search: search ? stringify(search) : undefined,
        });
    };

    private handleSearchClick = () => {
        if (this.isShowingSearch()) {
            this.setState({ query: null }, this.searchRedirect);
        } else {
            this.setState({ query: '' });
        }
    };

    private onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ query: event.currentTarget.value }, this.searchRedirectDebounced);
    };

    private searchRedirect = () => {
        const { orderBy } = this.props;
        this.commonRedirect(orderBy, this.state.query);
    };

    private onCancelFilters = () => {
        const { orderBy } = this.props;
        this.setState({ query: null });
        this.commonRedirect(orderBy, null);
    };

    private handleTextareaRef = (ref: HTMLTextAreaElement) => {
        this.textArea = ref;
    };

    private handleOnSavePost = (values: BlogPostFormData) => {
        const { group, onAddPost, pageRef } = this.props;
        onAddPost(group.id, pageRef, values);
    };

    private handleOnGuideComplete = (onGuideComplete, groupId, isClosedByUser) => {
        onGuideComplete(groupId, isClosedByUser);
    };
}

export default GroupFeed;
